import Login from "../components/Login/Login";
import MyPage from "../components/MyPage/MyPage";
import Order from "../components/Order/Order";
import Home from "../components/home/home";
import Coupon from "../components/Coupon/Coupon";
import FAQ from "../components/FAQ/FAQ";
import Policy from "../components/Policy/Policy";
import {ReactNode} from "react";
import PhoneVerification from "../components/PhoneVerification/PhoneVerification";
import Join from "../components/join/Join";
import OrderForm from "../components/OrderForm/OrderForm";
import OrderDone from "../components/OrderDone/OrderDone";
import Payment from "../components/Payment/Payment";
import Cscenter from "../components/Cscenter/Cscenter";
import Admin from "../components/Admin";
import AdminGuard from "../components/Admin/AdminGuard";
import Delivery from "../components/Delivery/Delivery";
import Fail from "../components/Payment/Fail";
import Contact from "../components/Contact/Contact";
import Pricing from "../components/Pricing/Pricing";
import VideoInterview from "../components/Admin/Users/VideoInterview";
import SharedPage from "../components/Shared/SharedPage";
import Links from "../components/Links/Links";
import Guide from "../components/OrderDone/Guide";
import AppInstallPage from "../components/AppInstallPage/AppInstallPage";

interface routes {
    name:string,
    path:string,
    element?:ReactNode,
    children:routes[],
}

export const routers:routes[] = [
    {
        name:`home`,       // 로그인
        path:`/`,
        element:<Home/>,
        children:[],
    },
    {
        name:`login`,       // 로그인
        path:`/login`,
        element:<Login/>,
        children:[],
    },
    {
        name:`join`,        // 회원가입
        path:`/join`,
        element:<Join/>,
        children:[],
    },
    {
        name:`mypage`,      // 마이페이지
        path:`/mypage`,
        element:<MyPage/>,
        children:[],
    },
    {
        name:`coupon`,
        path:`/mypage/coupon`,
        element:<Coupon/>,
        children:[],
    },
    {
        name:`order`,       // 상품결제
        path:`/order`,
        element:<Order/>,
        children:[],
    },
    {
        name:`order_form`,       // 결제진행(쿠폰)
        path:`/order/order_form`,
        element:<OrderForm/>,
        children:[],
    },
    {
        name:`order_done`,       // 결제완료
        path:`/order/order_done`,
        element:<OrderDone/>,
        children:[],
    },
    {
        name:`payment`,         // 결제창
        path:`/order/payment`,
        element:<Payment/>,
        children:[],
    },
    {
        name:`fail`,         // 결제 실패
        path:`/order/fail`,
        element:<Fail/>,
        children:[],
    },
    {
        name:`policy`,     // 약관동의
        path:`/policy`,
        element:<Policy/>,
        children:[],
    },
    {
        name:`privacy`,     // 개인정보처리방침
        path:`/privacy`,
        element:<Policy/>,
        children:[],
    },
    {
        name:`refund`,     // 개인 환불 정책
        path:`/refund`,
        element:<Policy/>,
        children:[],
    },
    {
        name:`faq`,     // faq
        path:`/faq`,
        element:<FAQ/>,
        children:[],
    },
    {
        name:`phone-verification`, // 휴대폰 인증
        path:`/phone-verification`,
        element:<PhoneVerification/>,
        children:[],
    },
    {
        name:`cs_center`, // 1:1문의
        path:`/cs_center`,
        element:<Cscenter/>,
        children:[],
    },
    {
        name:`delivery`, // 실물책 신청
        path:`/delivery`,
        element:<Delivery/>,
        children:[],
    },
    {
        name:`contact`, // 비즈니스 문의
        path:`/contact`,
        element:<Contact/>,
        children:[],
    },
    {
        name:`pricing`, // 실물책 신청
        path:`/pricing`,
        element:<Pricing/>,
        children:[],
    },
    {
        name:`guide`, // 자서전 제작 과정
        path:`/guide`,
        element:<Guide/>,
        children:[],
    },
    {
        name:`admin`, // 관리자 페이지
        path:`/admin`,
        element:<AdminGuard requiredPermission="admin"><Admin currentPage="dashboard" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_users`, // 사용자 관리
        path:`/admin/users`,
        element:<AdminGuard requiredPermission="admin"><Admin currentPage="users" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_user_detail`, // 사용자 상세보기
        path:`/admin/users/detail/:userId`,
        element:<AdminGuard requiredPermission="admin"><Admin currentPage="user-detail" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_interview_detail`, // 인터뷰 상세보기
        path:`/admin/users/:userId/projects/:projectId/episodes/:episodeId/interview`,
        element:<AdminGuard requiredPermission="admin"><Admin currentPage="interview-detail" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_video_interview`, // 영상 인터뷰
        path:`/admin/users/:userId/projects/:projectId/episodes/:episodeId/video-interview`,
        element:<AdminGuard requiredPermission="admin"><VideoInterview /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_project_video_interview`, // 프로젝트 레벨 영상 인터뷰
        path:`/admin/users/:userId/projects/:projectId/video-interview`,
        element:<AdminGuard requiredPermission="admin"><VideoInterview /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_digitalbook_detail`, // 전자책 상세보기
        path:`/admin/users/:userId/projects/:projectId/books/:bookId`,
        element:<AdminGuard requiredPermission="admin"><Admin currentPage="digitalbook-detail" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_orders`, // 결제 관리
        path:`/admin/orders`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="orders" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_order_detail`, // 주문 상세보기
        path:`/admin/orders/detail/:orderId`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="order-detail" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_order_edit`, // 주문 수정
        path:`/admin/orders/edit/:orderId`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="order-edit" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_order_refund`, // 환불 처리
        path:`/admin/orders/refund/:orderId`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="order-refund" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_delivery`, // 실물책 주문관리
        path:`/admin/delivery`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="delivery" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_delivery_detail`, // 실물책 주문 상세보기
        path:`/admin/delivery/detail/:orderId`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="delivery-detail" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_coupons`, // 쿠폰 관리
        path:`/admin/coupon`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="coupons" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_coupon_detail`, // 쿠폰 상세보기
        path:`/admin/coupon/:couponId`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="coupon-detail" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_coupon_edit`, // 쿠폰 수정
        path:`/admin/coupon/:couponId/edit`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="coupon-edit" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_coupon_create`, // 쿠폰 생성
        path:`/admin/coupon/create`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="coupon-create" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_products`, // 상품 관리
        path:`/admin/products`,
        element:<AdminGuard requiredPermission="manager"><Admin currentPage="products" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_analytics`, // 통계 분석
        path:`/admin/analytics`,
        element:<AdminGuard requiredPermission="admin"><Admin currentPage="analytics" /></AdminGuard>,
        children:[],
    },
    {
        name:`admin_settings`, // 시스템 설정
        path:`/admin/settings`,
        element:<AdminGuard requiredPermission="system"><Admin currentPage="settings" /></AdminGuard>,
        children:[],
    },
    {
        name:`shared`, // 공유 페이지
        path:`/shared/:type/:code`,
        element:<SharedPage />,
        children:[],
    },
    {
        name:`links`, // 앱 링크 페이지
        path:`/link/:page`,
        element:<Links />,
        children:[],
    },
    {
        name:`app-install`, // 앱 설치 페이지
        path:`/app-install`,
        element:<AppInstallPage />,
        children:[],
    },
]